module.exports = __webpack_public_path__ + "img/introductionToPython_sign.acb7a836.png";